
<div class="modal-dialog" style="max-width: 750px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Select Bulk Order</h4>
      <button class="close" type="button" (click)="close()">&times;</button>
    </div>
    <div class="modal-body">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Order Number</th>
            <th>Order Date</th>
            <th>Total Quantity</th>
            <th>Available Quantity</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of assignable.availableBulkOrderItems">
            <td>{{ c.orderNumber }}</td>
            <td>{{ c.orderDate }}</td>
            <td>{{ c.quantity }}</td>
            <td>{{ c.quantityAvailable }}</td>
            <td>
              <button class="btn btn-primary btn-sm float-right" (click)="select(c)">Assign</button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td>
              <button class="btn btn-outline-danger btn-sm float-right" (click)="select(null)">Clear</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">Cancel</button>
    </div>
  </div>
</div>